import React from 'react';
import PageHero from '../../components/PageHero';
import AnimatedSection from '../../components/AnimatedSection';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function BusinessCommercial() {
  return (
    <div className="bg-white">
      <PageHero 
        title="Business Commercial" 
        description="Impenetrable property and asset protection designed exclusively for high-value physical locations and inventory."
        image="https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=2069&auto=format&fit=crop"
      />
      <section className="py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
            <AnimatedSection>
              <div className="w-16 h-2 bg-red-600 mb-8"></div>
              <h2 className="text-4xl md:text-5xl font-extrabold text-zinc-900 mb-8 tracking-tight">Fortify Your Empire.</h2>
              <p className="text-zinc-600 text-xl mb-8 font-light leading-relaxed">
                Standard property insurance leaves gaping holes. Our Commercial Property policies are engineered to build an ironclad wall around your physical assets. From catastrophic weather to targeted theft, we ensure your operational foundation remains untouchable.
              </p>
              <ul className="space-y-5 mb-12">
                {['Architectural & Structural Coverage', 'High-Value Equipment Protection', 'Critical Inventory Safeguards', 'Classified Document Recovery'].map((item, i) => (
                  <motion.li whileHover={{ x: 5 }} key={i} className="flex items-center gap-4 text-zinc-800 font-medium text-lg">
                    <div className="bg-red-50 p-2 rounded-lg text-red-600"><SafeIcon icon={FiIcons.FiCheck} /></div> {item}
                  </motion.li>
                ))}
              </ul>
              <Link to="/contact" className="inline-block bg-zinc-900 text-white px-8 py-4 rounded-full font-bold hover:bg-red-600 transition-colors shadow-xl uppercase tracking-wide text-sm">
                Secure Your Assets
              </Link>
            </AnimatedSection>
            <AnimatedSection delay={0.2} className="relative">
              <div className="absolute inset-0 bg-red-600 translate-x-4 -translate-y-4 rounded-3xl"></div>
              <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop" alt="Commercial Property" className="relative z-10 rounded-3xl shadow-2xl w-full h-[600px] object-cover" />
            </AnimatedSection>
          </div>
        </div>
      </section>
    </div>
  );
}